import { render, staticRenderFns } from "./AtualizarMeuCadastro.vue?vue&type=template&id=50ad47e4"
import script from "./AtualizarMeuCadastro.vue?vue&type=script&lang=js"
export * from "./AtualizarMeuCadastro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports